import html2canvas from 'html2canvas'
import randomHash from './randomHash'
// function downloadImage(elm, nameOrArg, ...rest) {
//   let name = ''
//   let args = []
//   const isSelector = typeof nameOrArg === 'string' && (nameOrArg.startsWith('.') || nameOrArg.startsWith('#'))

//   if (Array.isArray(nameOrArg) || isSelector) {
//     name = randomHash()
//     args = [nameOrArg, ...rest]
//   } else {
//     try {
//       if (!nameOrArg) {
//         name = randomHash()
//       } else {
//         name = String(nameOrArg)
//           .trim()
//           .replace(/[\/\\:\*\?"<>\|]/g, '')
//       }

//       // name = name || randomHash()
//       args = rest
//     } catch {
//       name = randomHash()
//       args = [nameOrArg, ...rest]
//     }
//   }

//   if (!name || typeof name !== 'string' || !name.trim()) {
//     name = randomHash()
//   }

//   let canvasBox = null
//   if (typeof elm === 'string') {
//     if (!elm.trim()) {
//       console.warn('onDownloadImage: 传入的截图元素选择器无效')
//       return
//     }
//     canvasBox = document.querySelector(elm)
//   } else if (elm instanceof Element) {
//     canvasBox = elm
//   } else {
//     console.warn('onDownloadImage: 传入的截图元素无效')
//     return
//   }

//   if (!canvasBox) {
//     console.warn('onDownloadImage: 无法找到截图元素')
//     return
//   }

//   args.forEach(arg => {
//     if (typeof arg !== 'string' || !document.querySelector(arg)) {
//       console.warn(`onDownloadImage: 无效的隐藏元素选择器 ${arg}`)
//     }
//   })
//   // 截图
//   // 手动创建一个 canvas 标签
//   const canvas = document.createElement('canvas')
//   // 获取父标签，意思是这个标签内的 DOM 元素生成图片

//   // 只隐藏截图区域内的目标元素
//   if (args.length > 0 && canvasBox) {
//     args.forEach(selector => {
//       const elms = canvasBox.querySelectorAll(selector)
//       elms.forEach(el => {
//         el.style.opacity = 0
//       })
//     })
//   }

//   // 获取截图区域宽高
//   const width = canvasBox.offsetWidth
//   const height = canvasBox.offsetHeight
//   // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
//   canvas.width = width * 2
//   canvas.height = height * 2
//   canvas.style.width = width + 'px'
//   canvas.style.height = height + 'px'
//   const context = canvas.getContext('2d')
//   context.scale(2, 2)
//   const options = {
//     width: width,
//     height: height * 2,
//     backgroundColor: '#FFFFFF',
//     canvas: canvas,
//     useCORS: true,
//     scale: 1,
//     dpi: 300
//   }
//   html2canvas(canvasBox, options).then(canvas => {
//     // toDataURL 图片格式转成 base64
//     let dataURL = canvas.toDataURL('image/png')
//     onDownloadImage(dataURL, name)
//   })
//   if (args.length > 0) {
//     args.forEach(item => {
//       let elms = canvasBox.querySelectorAll(item)
//       if (elms.length > 0) {
//         elms.forEach(el => {
//           el.style.opacity = 1
//         })
//       }
//     })
//   }
// }

/**
 *
 * @param {*} elm elm:截图区域class或id且为页面唯一标识,例如：'.box'、'#box'
 * @param {*} name 文件名
 * @param  {...any} elms 截图区域内需要隐藏的参数,例如'.tools-box'、'#tools-box'多个参数或['.tools-box', '#tools-box']
 * @returns
 */
function downloadImage({ elm, name = randomHash(), elms }) {
  let canvasBox = null
  if (typeof elm === 'string') {
    if (!elm.trim()) {
      console.warn('downloadImage: 传入的截图元素选择器无效')
      return
    }
    canvasBox = document.querySelector(elm)
    console.log('canvasBox', canvasBox)
    if (!canvasBox) {
      console.warn('downloadImage: 无法找到截图元素')
      return
    }
  } else if (elm instanceof Element) {
    canvasBox = elm
  } else {
    console.warn('downloadImage: 传入的截图元素无效')
    return
  }
  let hidenElms = []
  if (elms) {
    if (typeof elms === 'string') {
      hidenElms = [elms]
    } else {
      hidenElms = [...elms]
    }
  }
  if (hidenElms.length > 0) {
    hidenElms.forEach(selector => {
      let classStr = elm + ' ' + selector
      const elms = canvasBox.querySelectorAll(classStr)
      if (elms.length > 0) {
        elms.forEach(el => {
          el.style.opacity = 0
        })
      } else {
        console.warn(`downloadImage: 无效的隐藏元素选择器 ${selector}`)
      }
    })
  }
  const canvas = document.createElement('canvas')
  //   // 获取截图区域宽高
  const width = canvasBox.offsetWidth
  const height = canvasBox.offsetHeight
  // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
  canvas.width = width * 2
  canvas.height = height * 2
  canvas.style.width = width + 'px'
  canvas.style.height = height + 'px'
  const context = canvas.getContext('2d')
  context.scale(2, 2)
  const options = {
    width: width,
    height: height * 2,
    backgroundColor: '#FFFFFF',
    canvas: canvas,
    useCORS: true,
    scale: 1,
    dpi: 300
  }
  html2canvas(canvasBox, options).then(canvas => {
    // toDataURL 图片格式转成 base64
    let dataURL = canvas.toDataURL('image/png')
    onDownloadImage(dataURL, name)
  })
  if (hidenElms.length > 0) {
    hidenElms.forEach(item => {
      let classStr = elm + ' ' + item
      let elms = canvasBox.querySelectorAll(classStr)
      if (elms.length > 0) {
        elms.forEach(el => {
          el.style.opacity = 1
        })
      } else {
        console.warn(`downloadImage: 无效的隐藏元素选择器 ${item}`)
      }
    })
  }
}
// 下载图片
function onDownloadImage(url, name) {
  // 如果是在网页中可以直接创建一个 a 标签直接下载
  let a = document.createElement('a')
  a.href = url
  a.download = name + '.png'
  a.click()
}

export default { downloadImage }

export { downloadImage }
